import { APPS_CATALOG_QUERY_KEY } from "jadro-pico-app/Api/queryKeys";

export const QueryKeys = {
  me: ["me"] as const,
  appsCatalog: APPS_CATALOG_QUERY_KEY,
  racerProfile: ["racerProfile"] as const,
  userProfile: ["userProfile"] as const,
} as const;
